<template>
    <div class="modal hide fade in" id="modalEnvio" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title label-black">{{pageTitle}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

                  <div class="row">
                        <div class="form-group col-12">
                            <label class="label-black">Área:</label>
                            <input type="text" id="nombreArea_div" class="form-control" v-model="DefinicionSede.Area.Nombre" readonly/>
                        </div>
                  </div>
                  <div class="row">
                        <div class="form-group col-12">
                            <label class="label-black">Año de los Documentos Inicial:</label>
                            <input type="number" id="anioInicio_div" class="form-control" v-model="DefinicionSede.AnioInicio"/>
                        </div>
                  </div>
                  <div class="row">
                        <div class="form-group col-12">
                            <label class="label-black">Año de los Documentos Final:</label>
                            <input type="number" id="anioFinal_div" class="form-control" v-model="DefinicionSede.AnioFinal"/>
                        </div>
                  </div>
                  <div class="row">
                        <div class="form-group col-12">
                            <label class="label-black">Sede de Archivo:</label>
                            <sedes
                                v-on:valorParaElPadre="cambioDeSede" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="'filtroDeBusqueda_Area'" 
                                :parametros="parametros_SedeArchivo" 
                                :valorDefinido="parametros_SedeArchivo.sedeArchivoId" 
                                :key="parametros_SedeArchivo.sedeArchivoId"
                            ></sedes>
                        </div>
                  </div>              
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" id="botonCancelar" >Cancelar</button>
          <button type="button" class="btn btn-custom" id="botonAceptar" >Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'


export default {
    components :{
        sedes : catalogos.ArchivoJudicial.C012SedesArchivo
    },
    data(){
        return{
            enumeraciones,
            DefinicionSede: {
                DefinicionSedeArchivoId: 0,
                Area: {
                    AreaId: 0,
                    Nombre: ""
                },
                AnioInicio: 1900,
                AnioFinal: moment().format('YYYY'),
                SedeArchivo: {
                    SedeArchivoId: 0,
                    Nombre: ""
                }
            },
            parametros_SedeArchivo:
                {
                    sedeArchivoId: -1
                }
        }
    },
    props:  {
        definicionSedeId: {
            type: Number,
            default: 0
        },
        DefinicionArea: {},
        ListaDefiniciones: Array,
    },
    computed:{
        pageTitle(){
            if(this.definicionSedeId != null && this.definicionSedeId != undefined && this.definicionSedeId >0)
            {return "EDICIÓN DE DEFINICIÓN DE SEDE DEL ARCHIVO "} else {return "NUEVA DEFINICIÓN DE SEDE DEL ARCHIVO"}
            
        }
    },
    methods: {
        Mostrar: function () {
            $('#modalEnvio').modal('show');
            $('#botonCancelar').unbind('click').click(this.ModalClose);
            $('#closeModal').unbind('click').click(this.ModalClose);
            $('#botonAceptar').unbind('click').click(this.ModificarDefinicion);
            },
        ModalClose: function(){
            $('#modalEnvio').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('dialogo', false);
        },
        ObtenerDefinicion(){
            var peticion = {
                "DefinicionSedeArchivoId": this.definicionSedeId
            };
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.ObtenerDefinicion, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
                if (respuesta.data.SiHayError){
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    comun.SeEstaCargandoInformacion(false);
                }
                else
                {
                    this.DefinicionSede = respuesta.data.GetDefinicionSedes;
                    this.parametros_SedeArchivo.sedeArchivoId = this.DefinicionSede.SedeArchivo.SedeArchivoId;
                    comun.SeEstaCargandoInformacion(false);

                }
                comun.SeEstaCargandoInformacion(false);
                
            })
            .catch(e=> {
                console.log("No Hay Respuesta del Servidor", e);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });
        },
        ModificarDefinicion(){
            if(this.VerificarDatos())
            {
                var peticion = {
                    "DefinicionSedeArchivo" : {
                        "DefinicionSedeArchivoId": this.DefinicionSede.DefinicionSedeArchivoId,
                        "Area": {"AreaId" :this.DefinicionSede.Area.AreaId},
                        "AnioInicio": this.DefinicionSede.AnioInicio,
                        "AnioFinal": this.DefinicionSede.AnioFinal,
                        "SedeArchivo": {"SedeArchivoId": this.parametros_SedeArchivo.sedeArchivoId}
                    }
                };
                
                if(peticion.DefinicionSedeArchivo.DefinicionSedeArchivoId == 0)
                {
                    if(this.VerificarDefiniciones(peticion))
                    {
                        this.LlamarApi(peticion);
                    }
                }
                else
                {
                    this.LlamarApi(peticion);
                }
            }
        },
        cambioDeSede(datos){
            this.parametros_SedeArchivo.sedeArchivoId = parseInt(datos.target.value);
        },
        VerificarDatos(){
            if(this.DefinicionSede.AnioInicio == null || this.DefinicionSede.AnioInicio == undefined || this.DefinicionSede.AnioInicio == 0)
            { 
                comun.mensajeDeAlerta("Verificar el Año del documento en Inicio", null, null);
                return false;
            };
            if(this.DefinicionSede.AnioFinal == null || this.DefinicionSede.AnioFinal == undefined || this.DefinicionSede.AnioFinal == 0)
            { 
                comun.mensajeDeAlerta("Verificar el Año del documento en Fin", null, null);
                return false;
            };
            if(this.DefinicionSede.AnioInicio > this.DefinicionSede.AnioFinal)
            { 
                comun.mensajeDeAlerta("Rango Inicial no puede ser mayor que final", null, null);
                return false;
            };
            if(this.parametros_SedeArchivo.sedeArchivoId == -1)
            {
                comun.mensajeDeAlerta("Seleccionar una sede para el resguardo del documento", null, null);
                return false;
            };
            return true
        },
        VerificarDefiniciones(info){
            var condicion = true;

            $.each(this.ListaDefiniciones, function(index, listado)
            {
                
                if(parseInt(info.DefinicionSedeArchivo.AnioInicio) > parseInt(listado.AnioInicio) && parseInt(info.DefinicionSedeArchivo.AnioInicio) < parseInt(listado.AnioFinal) ||
                    parseInt(info.DefinicionSedeArchivo.AnioFinal) > parseInt(listado.AnioInicio) && parseInt(info.DefinicionSedeArchivo.AnioFinal) < parseInt(listado.AnioFinal) )                     
                {
                    comun.mensajeDeAlerta("Existe traslape en otra definición, verificar", null, null);
                    condicion= false;
                    return false;
                }; 
                if(listado.AnioInicio == info.DefinicionSedeArchivo.AnioInicio && listado.AnioFinal == info.DefinicionSedeArchivo.AnioFinal )
                {
                    comun.mensajeDeAlerta("Ya existe una definición con mismo rango de periodo, verificar", null, null);
                    condicion= false;
                    return false;
                };
                if(listado.AnioInicio == info.DefinicionSedeArchivo.AnioInicio && listado.AnioFinal != info.DefinicionSedeArchivo.AnioFinal )
                {
                    comun.mensajeDeAlerta("Ya existe una definición con mismo inicio de rango de periodo, verificar", null, null);
                    condicion= false;
                    return false;
                };
                if(listado.AnioInicio != info.DefinicionSedeArchivo.AnioInicio && listado.AnioFinal == info.DefinicionSedeArchivo.AnioFinal )
                {
                    comun.mensajeDeAlerta("Ya existe una definición con mismo fin de rango de periodo, verificar", null, null);
                    condicion= false;
                    return false;
                };
                              
            });

            
            return condicion;
        },
        LlamarApi(definicion){
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.GuardarDefinicion, definicion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
                if (respuesta.data.SiHayError){
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    comun.SeEstaCargandoInformacion(false);
                }
                else
                {
                    var mensaje ="";
                    if (this.DefinicionSede.DefinicionSedeArchivoId > 0)
                    {
                        mensaje ="Se modificado la definición de sede de Resguardo del Archivo Judicial.";
                    }
                    else
                    {
                        mensaje ="Se ha agregado una nueva definición de sede de Resguardo del Archivo Judicial.";
                    }
                    comun.mensajeDeAlerta(mensaje, null, null);
                    comun.SeEstaCargandoInformacion(false);
                    this.ModalClose();
                    }
                    comun.SeEstaCargandoInformacion(false);
                        
                    })
                    .catch(e=> {
                    console.log("No Hay Respuesta del Servidor", e);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });
        }
    },
    mounted(){
        this.DefinicionSede.Area = this.DefinicionArea;
        
        this.Mostrar();
        if(this.definicionSedeId > 0)
        {
            this.ObtenerDefinicion();
        }
    }
}
</script>
<style scoped>
input[type="text"]:read-only {
    background: #504f54;
  }
input[type="text"]:read-only:focus {
      color: #fff;
    }
textarea[type="text"]:read-only {
    background: #504f54;
  }    
textarea[type="text"]:read-only:focus {
      color: #fff;
    }
.modal-content {
    background-color:  #7e7f74;
}
.modal-header {
        background-color:  #007573;
    }
    .label-black {
  color: black;
}
.btn-custom {
  background-color: #004746;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/AddEditDefinicion.vue